import React from 'react';
import Navbar from './Navbar';

interface AppShellProps {
  children: React.ReactNode;
}

const AppShell: React.FC<AppShellProps> = ({ children }) => {
  return (
    <>
      <Navbar />
      <main className="app-shell" data-route-scroll-root="true">
        {children}
      </main>
    </>
  );
};

export default AppShell;
